export default "__VITE_ASSET__Kat8Ln8___"